import { render, staticRenderFns } from "./InstrumentJigEdit.vue?vue&type=template&id=ecd80d72"
import script from "./InstrumentJigEdit.vue?vue&type=script&lang=js"
export * from "./InstrumentJigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports